module.exports = __webpack_public_path__ + "img/24.7622f107.jpg";